import * as React from 'react';
import { useRef } from 'react';
import { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../API/httpCommon';
import { RegistrationModel } from '../../Model/RegistrationModel';
import $, { event } from "jquery";
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { setUserDetails, getUserDetails } from '../../Utility/UserUtility';
import Spinner from '../Spinner/Spinner';
import './Header.css'

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import { ValueSetter } from 'date-fns/parse/_lib/Setter';
import { useNavigate } from 'react-router-dom';


const Header = (prop: any) => {

    const navigate = useNavigate();

    const [EmailMobile, setEmailMobile] = useState<any>('');
    const [ShowOTPPanel, setShowOTPPanel] = useState(false);
    const [GeneratedOTP, setGeneratedOTP] = useState<any>('');
    const [EnteredOTP, setEnteredOTP] = useState<any>('');
    const [TotalCartItem, setTotalCartItem] = useState(0);
    const [LoggedInUserDetails, setLoggedInUserDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [Search, setSearch] = useState<any>({ Text: '', Value: '' });
    const [SearchOptions, setSearchOptions] = useState<any>([]);

    useEffect(function () {
        setTotalCartItem(GetCart().length);
        setLoggedInUserDetails(getUserDetails())
    }, []);




    const sendOTP = (event: any) => {

        setIsLoading(true);
        if (EmailMobile) {

            let model: RegistrationModel = new RegistrationModel();
            //model.Email = "";
            model.MobileOrEmail = EmailMobile

            const data = {
                MobileOrEmail: EmailMobile
            }

            apiPost("api/User/ValidateUser", data).then((res: any) => {

                setShowOTPPanel(true);
                setGeneratedOTP(res?.OTP);
                setIsLoading(false);
            });
        }
        else {
            setShowOTPPanel(false);
            setIsLoading(false);
        }

    }

    const loginRegister = (event: any) => {

        if (GeneratedOTP !== undefined && GeneratedOTP !== null && GeneratedOTP !== "" && GeneratedOTP === EnteredOTP) {

            let model: RegistrationModel = new RegistrationModel();
            //model.Email = "";
            model.MobileOrEmail = EmailMobile
            const data = {
                MobileOrEmail: EmailMobile
            }

            apiPost("api/User/LoginRegister", data).then((res: any) => {

                if (res !== undefined && res !== null && res !== "") {
                    setUserDetails(res);
                    setLoggedInUserDetails(res);
                    $("#UserName").text(res.User.User_Name);
                    $("#btnLogin").click();

                }


            });
        }


    }

    const onChangeSearch = (event: any, item: any) => {
        if (item !== undefined && item !== null && item.Text !== null && item.Text !== '') {
            setSearch({ Text: item.Text, Value: item.Value });
        }
        else {
            setSearch(null as any);
        }
    }


    const onSearchInputChange = (item: any) => {

        setSearch({ Text: item, Value: 0 });

        apiGet('api/Search/SearchItem?SearchText=' + item).then((item) => {

            if (item?.Data !== null && item?.Data?.length > 0) {
                let _modelList: any[] = [];
                item?.Data?.forEach((val: any, i: any) => {
                    _modelList.push({ Text: val.Item_Title, Value: val.Item_Title });
                })
                setSearchOptions(_modelList);

            }
        })
    }


    const onSearch = () => {

        navigate('/search?strm=' + Search?.Text)

    }


    const handleKeyDown = (event: any) => {

        if (event.key === 'Enter') {
            navigate('/search?strm=' + Search?.Text)
        }
    };

    const handleLogout = () => {
        setUserDetails(null);
        setLoggedInUserDetails(null);
        navigate('/');
    }


    return (
        <>

            {(isLoading && <Spinner></Spinner>)}

            <button id="back-top" className="back-to-top">
                <i className="fa-solid fa-chevron-up"></i>
            </button>

            <div className="fix-area">
                <div className="offcanvas__info">
                    <div className="offcanvas__wrapper">
                        <div className="offcanvas__content">
                            <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                                <div className="offcanvas__logo">
                                    <a href="/">
                                        <img src="/assets/img/logo/meri_pustak_logo.png" alt="logo-img" />
                                    </a>
                                </div>
                                <div className="offcanvas__close">
                                    <button>
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="mobile-menu fix mb-3"></div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="offcanvas__overlay"></div>
            <div className="fixed-header">
                <div className="header-top-1">
                    <div className="container">
                        <div className="header-top-wrapper">
                            <ul className="contact-list">
                                <li>
                                    <i className="fa-regular fa-phone"></i>
                                    <a href="tel:+18008917183">1800 891 7183</a>
                                </li>
                                <li>
                                    <i className="far fa-envelope"></i>
                                    <a href="mailto:contactus@meripustak.com">contactus@meripustak.com</a>
                                </li>
                                <li>
                                    <i className="far fa-clock"></i>
                                    <span>Mon-Sat : 10am - 6pm</span>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.google.com/maps/place/MeriPustak/@28.6254014,77.1409133,17z/data=!4m8!3m7!1s0x390d0328d22b5e5b:0x55247584e66cce57!8m2!3d28.6254014!4d77.143102!9m1!1b1!16s%2Fg%2F11bxc7fwr_?entry=ttu&amp;g_ep=EgoyMDI1MDIyNi4xIKXMDSoASAFQAw%3D%3D">Google Reviews</a>
                                </li>
                            </ul>
                            {/* <ul className="list">
                                {!LoggedInUserDetails && <li><i className="fa-light fa-user"></i>
                                    <button id='btnLogin' data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                        Login
                                    </button>
                                </li>}

                                {LoggedInUserDetails && <li><i className="fa-light fa-user"></i>
                                    <span id='UserName'>{LoggedInUserDetails?.User?.User_Name}</span>
                                </li>
                                }
                            </ul> */}


                            {!LoggedInUserDetails && <ul className="list">
                                <li><i className="fa-light fa-user"></i>
                                    <button id='btnLogin' data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                        Login
                                    </button>
                                </li>
                            </ul>}

                            {LoggedInUserDetails && <ul className="list dropdown">
                                <li>
                                    <a id='UserName' className="dropbtn"> {LoggedInUserDetails?.User?.User_Name} <i className="fas fa-angle-down"></i> </a>
                                    <ul className="dropdown-content">
                                        <li><a href="#">View Profile</a></li>
                                        <li><a href="/Order">Order</a></li>
                                        <li><a href="/CancelRequest">Cancel Request</a></li>
                                        <li><a href="#">Return Request</a></li>
                                        <li><a onClick={handleLogout} >Logout</a></li>
                                    </ul>
                                </li>
                            </ul>
                            }
                        </div>
                    </div>
                </div>


                <header className="header-1">
                    <div className="mega-menu-wrapper">
                        <div className="header-main">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                        <div className="header-left">
                                            <div className="logo">
                                                <a href="/" className="header-logo">
                                                    <img src="/assets/img/logo/meri_pustak_logo.png" alt="logo-img" className="img-fluid logo" />
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="header-right" style={{ display: "block" }}>
                                            <div className="category-oneadjust gap-6 d-flex align-items-center">


                                                <div className="search-toggle-box d-md-block">
                                                    <div className="input-area">
                                                        {/* <input type="text" placeholder="Search" /> */}

                                                        <Autocomplete
                                                            freeSolo
                                                            id="free-solo-2-demo"
                                                            value={Search as any}
                                                            isOptionEqualToValue={(option, value) => option.Text === value.Text}
                                                            //options={top100Films.map((option) => option.title)}
                                                            getOptionLabel={(option) => option.Text}
                                                            options={SearchOptions}
                                                            onChange={onChangeSearch}
                                                            onInputChange={(event, newInoutValue) => onSearchInputChange(newInoutValue)}
                                                            onKeyDown={handleKeyDown}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: null, // Remove the clear icon here
                                                                    }}
                                                                />
                                                            )}
                                                            disableClearable
                                                        />


                                                        <button id='btnSearch' className="cmn-btn" onClick={onSearch}>
                                                            <i className="far fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                        <div className="header-right menuicon">

                                            <div className="menu-cart">

                                                <a href="/Cart" className="cart-icon">
                                                    <span id='CartText'>{TotalCartItem}</span>
                                                    <i className="fa-regular fa-cart-shopping"></i>
                                                </a>

                                                {/* <div className="header-humbager ml-30">
                                                    <a className="sidebar__toggle">
                                                        <div className="bar-icon-2">
                                                            <img src="/assets/img/icon/icon-13.svg" alt="img" />
                                                        </div>
                                                    </a>
                                                </div> */}



                                                <div className="hamburger-menu">
                                                    <input id="menu__toggle" type="checkbox"   />
                                                    <label className="menu__btn" htmlFor="menu__toggle" >
                                                        <span></span>
                                                    </label>

                                                    <ul className="menu__box">
                                                        <li><a className="menu__item" href="/Medical-Books/cid-10002">Medical Books</a></li>
                                                        <li><a className="menu__item" href="/Auditing-and-Taxation-Books/cid-11300">Auditing & Taxation Books</a></li>
                                                        <li><a className="menu__item" href="/Legal-Books/cid-10031">Legal Books</a></li>
                                                        <li><a className="menu__item" href="/Mathematics-and-Statistics-Books/cid-10102">Mathematics & Statistics Books</a></li>
                                                        <li><a className="menu__item" href="/Science/cid-11280">Science Books</a></li>
                                                        <li><a className="menu__item" href="/Others-Books/cid-10105">Others Books</a></li>
                                                    </ul>
                                                </div>









                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </header>
                <header className="header-1 menuheader">
                    <div className="mega-menu-wrapper">
                        <div className="header-main">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                        <div className="header-center">

                                            <div className="mean__menu-wrapper">
                                                <div className="main-menu">
                                                    <nav id="mobile-menu">
                                                        <ul>
                                                            {/* <li>
                                                                 <a href="/Books/cid-10001">
                                                                    Book Store
                                                                </a> 
                                                            </li>
                                                            <li>
                                                                 <a href="/HomeStore/cid-11374">
                                                                    Home Store
                                                                </a> 
                                                            </li> */}

                                                            <li>
                                                                <a href="/Medical-Books/cid-10002">
                                                                    Medical Books
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/Auditing-and-Taxation-Books/cid-11300">
                                                                   Auditing & Taxation Books
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/Legal-Books/cid-10031">
                                                                  Legal Books
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/Mathematics-and-Statistics-Books/cid-10102">
                                                                   Mathematics & Statistics Books
                                                                </a>
                                                            </li>
                                                             <li>
                                                                <a href="/Science/cid-11280">
                                                                   Science Books
                                                                </a>
                                                            </li>
                                                             <li>
                                                                <a href="/Others-Books/cid-10105">
                                                                  Others Books
                                                                </a>
                                                            </li>


                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </header>
            </div>

            {/* <div className=" breadcrumb-padding-180"></div> */}

            {/* <!-- Login Modal --> */}
            <div className="modal fade modal-fullscreen-md-down" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">

                            <div className="identityBox">
                                <div className="close-btn">
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                                </div>

                                <div className="form-wrapper">
                                    <img style={{ width: "50%" }} src="assets/img/otp.jpg" className=" center" /><br />
                                    <h3 id="registrationModalLabel">Verify with OTP</h3>

                                    {ShowOTPPanel && <div className="input-check remember-me">
                                        <div className="checkbox-wrapper">
                                            <label >
                                            </label>
                                        </div>
                                        <div className="text"> <a href="#" onClick={e => sendOTP(e)}>Resend OTP</a> </div>
                                    </div>}

                                    <input className="inputField" type="email" onChange={e => setEmailMobile(e.target.value)} name="email" placeholder="Phone Or Email" />

                                    {ShowOTPPanel && <input className="inputField" type="email" onChange={e => setEnteredOTP(e.target.value)} name="email" placeholder="Enter OTP" />
                                    }

                                    {!ShowOTPPanel && <div className="loginBtn">
                                        <a className="theme-btn rounded-0" onClick={e => sendOTP(e)} > Send OTP </a>
                                    </div>}

                                    {ShowOTPPanel && <div className="loginBtn">
                                        <a href="#" onClick={e => loginRegister(e)} className="theme-btn rounded-0"> Log in </a>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Header;